import { NgModule } from '@angular/core';
import { CgpComponentBrowserDirective } from './cgp-component-browser.directive';
import { CgpComponentBrowserComponent } from './cgp-component-browser.component';

@NgModule({
    exports: [
        CgpComponentBrowserComponent
    ],
    declarations: [
        CgpComponentBrowserDirective,
        CgpComponentBrowserComponent
    ]
})
export class CgpComponentBrowserModule { }
